import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "./Tooltip";

const Contact = () => {
  const form = useRef();
  const [sendingMail, setSendingMail] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSendingMail(true);
    emailjs
      .sendForm(
        "service_i8Fk3ms",
        "template_siFcin9",
        form.current,
        "c9HsFgGF0tFWyVnAL",
      )
      .then(
        (result) => {
          document.getElementById("contact-form").reset();
          toast.success("Message sent successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          console.log(result.text);
          setSendingMail(false);
        },
        (error) => {
          toast.error("Something went wrong!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          console.log(error.text);
          setSendingMail(false);
        },
      );
  };

  return (
    <section id="contact" className="section bg-primary">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 text-center text-lg-start wow fadeInUp">
            <h2 className="text-10 fw-600 mb-5" style={{ color: "#FFFFFF " }}>
              Let's get in touch
            </h2>
            <p className="text-5 mb-5" style={{ color: "#E8EEFF " }}>
              I enjoy discussing new financial strategies, investment
              opportunities, and business challenges. Please share as much info
              as possible so we can get the most out of our first conversation.
            </p>
            <h3 className="text-5 fw-600" style={{ color: "#FFFFFF " }}>
              Living In:
            </h3>
            <address className="text-4" style={{ color: "#BDC8FF  " }}>
              Rancho Palos Verdes, California, USA.
            </address>
            <h3 className="text-5 fw-600" style={{ color: "#FFFFFF " }}>
              Call:
            </h3>
            <p className="text-4" style={{ color: "#BDC8FF  " }}>
              (213) 328-9074
            </p>
            <ul className="social-icons social-icons-lg justify-content-center justify-content-lg-start mt-5">
              <li className="social-icons-twitter">
                <Tooltip text="linkedin" placement="top">
                  <a
                    href="https://www.linkedin.com/in/dane-barata-978103aa/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-linkedin"
                      style={{ color: "#FFFFFF " }}
                    />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-facebook">
                <Tooltip text="Facebook" placement="top">
                  <a
                    href="https://www.facebook.com/dana.barata/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-facebook"
                      style={{ color: "#FFFFFF " }}
                    />
                  </a>
                </Tooltip>
              </li>
              {/* <li className="social-icons-instagram">
                <Tooltip text="Instagram" placement="top">
                  <a
                    href="http://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-github">
                <Tooltip text="Github" placement="top">
                  <a
                    href="http://www.github.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-dribbble">
                <Tooltip text="Dribbble" placement="top">
                  <a
                    href="http://www.dribbble.com/harnishdesign/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-dribbble" />
                  </a>
                </Tooltip>
              </li> */}
            </ul>
          </div>
          {/* <div
            className="col-lg-6 ms-auto mt-5 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Estimate your Project?
            </h2>
            <form
              id="contact-form"
              className="form-border"
              method="post"
              ref={form}
              onSubmit={sendEmail}
            >
              <div className="row g-4">
                <div className="col-12">
                  <label className="form-label" htmlFor="name">
                    What is Your Name:
                  </label>
                  <input
                    id="name"
                    name="user_name"
                    type="text"
                    className="form-control py-1"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label" htmlFor="email">
                    Your Email Address:
                  </label>
                  <input
                    id="email"
                    name="user_email"
                    type="email"
                    className="form-control py-1"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label" htmlFor="form-message">
                    How can I Help you?:
                  </label>
                  <textarea
                    id="form-message"
                    name="message"
                    className="form-control py-1"
                    rows={4}
                    required
                    defaultValue={""}
                  />
                </div>
                <div className="col-12 text-center text-lg-start">
                  <button
                    id="submit-btn"
                    className="btn btn-dark rounded-0"
                    type="submit"
                  >
                    {sendingMail ? (
                      <>
                        <span
                          role="status"
                          aria-hidden="true"
                          className="spinner-border spinner-border-sm align-self-center me-2"
                        ></span>
                        Sending......
                      </>
                    ) : (
                      <>
                        Send{" "}
                        <span className="ms-3">
                          <i className="fas fa-arrow-right" />
                        </span>
                      </>
                    )}
                  </button>
                </div>
                <ToastContainer />
              </div>
            </form>
          </div> */}

          <div
            className="col-lg-6 ms-auto mt-5 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="d-flex flex-column h-100 justify-content-center">
              {/* Forbes Feature */}
              <div
                className="p-4 rounded mb-4"
                style={{ backgroundColor: "rgb(26 31 60 / 37%)" }}
              >
                <span
                  className="fw-600 text-uppercase"
                  style={{
                    fontSize: "11px",
                    letterSpacing: "3px",
                    color: "#BDC8FF",
                  }}
                >
                  Featured In
                </span>
                <h3 className="text-white fw-600 text-6 mt-2 mb-3">
                  "The Nonprofit CFO: Managing an NGO's Finance Function"
                </h3>
                <p className="text-light text-3 mb-4">
                  Dane was featured in Forbes for his expertise in nonprofit
                  financial leadership, sharing insights on managing complex
                  finance functions and driving organizational growth at scale.
                </p>
                <a
                  href="https://www.forbes.com/sites/jeffthomson/2020/06/19/the-nonprofit-cfo-managing-an-ngos-finance-function/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn fw-600 me-3"
                  style={{ backgroundColor: "#4B6BF5", color: "white" }}
                >
                  <i className="fab fa-forbes me-2" />
                  Read on Forbes
                </a>
              </div>

              {/* LinkedIn CTA */}
              <div
                className="p-4 rounded"
                style={{ backgroundColor: "rgb(26 31 60 / 37%)" }}
              >
                <span
                  className="fw-600 text-uppercase"
                  style={{
                    fontSize: "11px",
                    letterSpacing: "3px",
                    color: "#BDC8FF",
                  }}
                >
                  Let's Connect
                </span>
                <h3 className="text-white fw-600 text-6 mt-2 mb-3">
                  Find me on LinkedIn
                </h3>
                <p className="text-light text-3 mb-4">
                  25+ years of financial leadership across Fortune 500
                  companies, startups, and nonprofits. Follow along for insights
                  on finance, entrepreneurship, and investment.
                </p>
                <a
                  href="https://www.linkedin.com/in/dane-barata-978103aa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn fw-600"
                  style={{ backgroundColor: "#4B6BF5", color: "white" }}
                >
                  <i className="fab fa-linkedin me-2" />
                  View LinkedIn Profile
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
